<div class="mt-1 pl-2 py-2 text-sm font-bold text-brand-danger">
    <ng-content></ng-content>
</div>